import { useContext } from 'react';

import { PageId } from '../../apis';
import { PageTrackingContext } from '../../contexts/PageTrackingContext';
import { PageViewContext } from '../../contexts/PageViewContext';

export function usePageView(): {
  pageId: PageId | null;
  pageViewId: string | null;
} {
  const fromContext = useContext(PageViewContext);
  const { currentPageView } = useContext(PageTrackingContext);

  // Prefer the scoped PageViewContext when available (inside a PageImpression).
  // Fall back to the global state for components rendered outside the page tree
  // (e.g. dialogs rendered by a root-level DialogProvider).
  if (fromContext.pageId !== null) {
    return fromContext;
  }
  return currentPageView;
}
